import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import Toggle from 'react-toggle';
import getLocale from '../../i18n/getLocale';

class CompaniesEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      name: '',
      abbreviation: '',
      refuel_export_email: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
  }

  // Handlers
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/empresa/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/empresas');
        if (responseJson.status === 'success') {
          self.setState({id: self.props.match.params.id,
            name: responseJson.data.main.name,
            abbreviation: responseJson.data.main.abbreviation,
            refuel_export_email: responseJson.data.main.refuel_export_email
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

    // Fetch salvando a edição
    edit(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        abbreviation: this.state.abbreviation,
        name: this.state.name,
        id: this.state.id,
        refuel_export_email: this.state.refuel_export_email
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/empresa', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Empresas.EditarEmpresa.titulo}</h3>
      <Link to="/empresas" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Empresas.EditarEmpresa.formulario.RazaoSocial}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.Empresas.EditarEmpresa.formulario.placeholder.RazaoSocial} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Empresas.EditarEmpresa.formulario.Trigrama}:</label>
              <input type="text" name="abbreviation" className="form-control" placeholder={this.locale.Empresas.EditarEmpresa.formulario.placeholder.Trigrama} value={this.state.abbreviation} onChange={this.handleChange.bind(this, 'abbreviation')} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Empresas.EditarEmpresa.formulario.RequerEmailAbastecimento}</label>
              <br/>
              <Toggle
                checked={this.state.refuel_export_email}
                name="refuel_export_email"
                onChange={this.handleToggleChange.bind(this, 'refuel_export_email')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Empresas.EditarEmpresa.formulario.botaoEditarEmpresa}</button>
          </div>
        </div>
      </form>

    </div>
  </div>
</div>
    );
  }
}

export default CompaniesEdit;



// WEBPACK FOOTER //
// ./src/Components/Companies/CompaniesEdit.js